import { downloadBase64Excel } from "@saleor/coupons/components/UnlockCodesTable/utils";
import { couponUnlockCodeTemplate } from "@saleor/coupons/queries";
import useAppState from "@saleor/hooks/useAppState";
import useNotifier from "@saleor/hooks/useNotifier";
import { useCallback } from "react";
import { useApolloClient } from "react-apollo";
import { useIntl } from "react-intl";

const useDownloadTemplate = () => {
  const intl = useIntl();
  const notify = useNotifier();
  const [, dispatchAppState] = useAppState();
  const client = useApolloClient();

  const downloadTemplate = useCallback(() => {
    dispatchAppState({
      payload: {
        value: true
      },
      type: "displayLoader"
    });
    client
      .query({
        fetchPolicy: "network-only",
        query: couponUnlockCodeTemplate
      })
      .then(response => {
        downloadBase64Excel(
          response.data.couponUnlockCodeTemplate,
          `Bulk_Unlock_Code_Template`
        );
      })
      .catch(() => {
        notify({
          status: "error",
          text: intl.formatMessage({
            defaultMessage: "An error occured."
          })
        });
      })
      .finally(() => {
        dispatchAppState({
          payload: {
            value: false
          },
          type: "displayLoader"
        });
      });
  }, []);

  return {
    downloadTemplate
  };
};

export default useDownloadTemplate;
